"use strict";
var core_1 = require('@angular/core');
var button_1 = require('../../button');
var common_1 = require('@angular/common');
var rxjs_1 = require('rxjs');
var SoundConfigPanel = (function () {
    function SoundConfigPanel() {
        var _this = this;
        this.timeUpdateSubject = new rxjs_1.Subject();
        this.timeUpdateSubject.debounceTime(250).subscribe(function (value) {
            _this.updateTime(value);
        });
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SoundConfigPanel.prototype, "sound", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], SoundConfigPanel.prototype, "updateTime", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], SoundConfigPanel.prototype, "removeSound", void 0);
    SoundConfigPanel = __decorate([
        core_1.Component({
            selector: 'sound-config-panel',
            template: "\n    <div class=\"flex\">\n      <input class=\"input\"\n        [value]=\"sound.get('time')\"\n        (input)=\"timeUpdateSubject.next($event.target.value)\" />\n      <rio-button [className]=\"'bg-red'\" (click)=\"removeSound()\">\n        <i class=\"fa fa-trash\"></i>\n      </rio-button>\n    </div>\n  ",
            pipes: [],
            directives: [common_1.NgStyle, button_1.RioButton],
            encapsulation: core_1.ViewEncapsulation.Emulated,
            styles: [],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }), 
        __metadata('design:paramtypes', [])
    ], SoundConfigPanel);
    return SoundConfigPanel;
}());
exports.SoundConfigPanel = SoundConfigPanel;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBTU8sZUFBZSxDQUFDLENBQUE7QUFFdkIsdUJBQTBCLGNBQWMsQ0FBQyxDQUFBO0FBRXpDLHVCQUdPLGlCQUFpQixDQUFDLENBQUE7QUFHekIscUJBQW9DLE1BQU0sQ0FBQyxDQUFBO0FBcUIzQztJQU9FO1FBUEYsaUJBWUM7UUFQUyxzQkFBaUIsR0FBb0IsSUFBSSxjQUFPLEVBQVUsQ0FBQztRQUdqRSxJQUFJLENBQUMsaUJBQWlCLENBQUMsWUFBWSxDQUFDLEdBQUcsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxVQUFBLEtBQUs7WUFDdEQsS0FBSSxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUN6QixDQUFDLENBQUMsQ0FBQztJQUNMLENBQUM7SUFWRDtRQUFDLFlBQUssRUFBRTs7bURBQUE7SUFDUjtRQUFDLFlBQUssRUFBRTs7d0RBQUE7SUFDUjtRQUFDLFlBQUssRUFBRTs7eURBQUE7SUF0QlY7UUFBQyxnQkFBUyxDQUFDO1lBQ1QsUUFBUSxFQUFFLG9CQUFvQjtZQUM5QixRQUFRLEVBQUUsd1RBU1Q7WUFDRCxLQUFLLEVBQUUsRUFBRTtZQUNULFVBQVUsRUFBRSxDQUFDLGdCQUFPLEVBQUUsa0JBQVMsQ0FBQztZQUNoQyxhQUFhLEVBQUUsd0JBQWlCLENBQUMsUUFBUTtZQUN6QyxNQUFNLEVBQUUsRUFBRTtZQUNWLGVBQWUsRUFBRSw4QkFBdUIsQ0FBQyxNQUFNO1NBQ2hELENBQUM7O3dCQUFBO0lBY0YsdUJBQUM7QUFBRCxDQUFDLEFBWkQsSUFZQztBQVpZLHdCQUFnQixtQkFZNUIsQ0FBQTtBQUFBLENBQUMifQ==


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/sequencer/sound-config-panel/index.ts
 ** module id = 964
 ** module chunks = 1
 **/